export default __webpack_public_path__ + "static/media/Mujer_computador@2x.235dc2a2.png";